import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ProjectComment" }
const _hoisted_2 = { class: "ProjectComment__main" }
const _hoisted_3 = { class: "ProjectComment__date" }

import { PropType } from "vue";
import { Comment, Project } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectComment',
  props: {
    comment: {
        type: Object as PropType<Comment>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.comment.comment), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.comment.date), 1)
  ]))
}
}

})